module.exports = __webpack_public_path__ + "static/img/2006.32493fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2006.jpg
// module id = 297
// module chunks = 0